export default "__VITE_ASSET__BlzbJiL8__"